import {Component} from '@angular/core';
import {AlertController, NavController, NavParams} from 'ionic-angular';
import {OrderService} from "../../services/OrderService";
import {OrderViewPage} from "../order-view/order-view";
import {OrderInfo} from "../nav/OrderInfo";
import {ActivityMonth, DateService} from "../../services/DateService";
import {MissionOrderPlanningReport, Order, PlanningEntry} from "../../model/Order";
import {PcheckService} from "../../services/PcheckService";
import {apiconfig} from "../../app/api.config";
import {OperationService} from "../../services/OperationService";
import {FieldTeam, FieldTeamStoreUniverse} from "../../model/FieldTeam";
import {AuthService} from "../../services/AuthService";
import {OrderEditPage} from "../order-edit/order-edit";
import {StartOrderPage} from "../start-order/start-order";
import {Locupa2Service} from "../../services/Locupa2Service";

/**
 * Generated class for the OrderListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-monthly-planning',
  templateUrl: 'monthly-view.html',
})
export class MonthlyPlanningPage {

  private orders: Order[];
  private planningReport: MissionOrderPlanningReport;

  public photoCounters: any;
  public ordersPerDate: Map<string, PlanningEntry[]> = new Map();

  public logaOperationPerName: Map<string, number> = new Map();

  public ordersPerDateKeys: string[] = [];
  public ordersPerOperationKeys: string[] = [];
  public ordersPerPearlsContextKeys: string[] = [];

  private currentMonth: ActivityMonth = this.dateService.getCurrentMonth()
  public loadingComplete: boolean = false;
  public showOperationPlanning: boolean;

  private selectedOperationId: number;
  private selectedOperationName: string;

  public iconsURL: string = apiconfig.LOGA_ICONS;
  // Array qui donne l'infor pour une operation d'afficher ou non les informations de présence
  public showPresenceCheckInfosPerOp: any;

  protected fieldTeamUniverse: FieldTeamStoreUniverse;

  protected currentAreaId: number;
  protected currentSectorId: number;
  private uiSearchWork: string;

  private uiShowSearch: boolean;
  private uiNumberOfVisibleOrders: number;
  private bubbleNumber: string[] = [];

  constructor(private navCtrl: NavController,
              private navParams: NavParams,
              private orderService: OrderService,
              private dateService: DateService,
              private pcheckService: PcheckService,
              private operationService: OperationService,
              private authService: AuthService,
              public locupa2Service: Locupa2Service,
              private alertCtrl: AlertController) {
  }

  ionViewWillEnter() {
    if (!this.currentMonth)
      this.currentMonth = this.dateService.getCurrentMonth();

    this.selectedOperationId = this.navParams.data['operationId'];
    this.selectedOperationName = this.navParams.data['operationName'];


    this.orderService.loadCurrentFieldTeam(false, null).then(fieldTeam => {
      this.fieldTeamUniverse = fieldTeam;
      this.searchOrders();
    })

    for (let i = 0; i < 15; i++) {
      this.bubbleNumber[i] = '&#' + (9312 + i) + ';';
    }

  }


  /**
   *
   * @param p_orderId
   * @param index
   */
  onLoadOrder(p_orderId: number, index: number) {

    let orderInfo: OrderInfo = new OrderInfo();

    let selectOrder: Order = this.planningReport.findOrderById(p_orderId);
    if (selectOrder != undefined) {
      orderInfo.order = selectOrder.id;

      // operation info
      orderInfo.operation.id = selectOrder.operation.id;
      orderInfo.operation.name = selectOrder.operation.name;

      // store info
      orderInfo.store.id = selectOrder.location.id;
      orderInfo.store.name = selectOrder.location.name;

      // load pcheck for this day
      this.pcheckService.findPcheck(selectOrder.id)
        .then((pchecks) => {
          if (selectOrder.customerEditPermissionAllowed)
            this.navCtrl.push(OrderEditPage, {orderInfo, pchecks});
          else
            this.navCtrl.push(OrderViewPage, {orderInfo, pchecks});
        }).catch(err => {
        let alert = this.alertCtrl.create({
          title: 'Erreur de Chargement',
          subTitle: "Impossible de retrouver les informations de présence pour l\' intervention. (id= " + p_orderId + ")." +
            "<br/>Merci ré-essayer ultérieurement, avec de meilleurs conditions de réseau. <br/> Vous pouvez également remonter cet incident à votre interlocuteur IMPACT.",
          buttons: ['Fermer'],
        });
        return alert.present();
      });

    } else {

      let alert = this.alertCtrl.create({
        title: 'Intervention',
        subTitle: "Impossible de retrouver les informations de cette intervention. (id= " + p_orderId + ")" +
          "<br/>Merci ré-essayer ultérieurement, avec de meilleurs conditions de réseau. <br/> Vous pouvez également remonter cet incident à votre interlocuteur IMPACT.",
        buttons: ['Fermer'],
      });
      alert.present();

    }
  }

  /**
   *
   * @param durationInMinutes
   */
  toFormatMissionDuration(durationInMinutes: number): string {
    let nbHours = Math.floor(durationInMinutes / 60);
    let nbMinutes = Math.floor(durationInMinutes % 60);

    if (nbMinutes && nbMinutes > 0) {
      return nbHours + "h" + nbMinutes;
    }

    return nbHours + "h";
  }

  nextMonth() {
    this.currentMonth.addMonth();
    this.searchOrders();
  }

  previousMonth() {
    this.currentMonth.removeMonth();
    this.searchOrders();
  }

  findOrdersBy(date: string, operation: string) {
    let orders = this.ordersPerDate.get(date);
    orders = orders.filter(o => o.contextName === operation);
    return orders;
  }

  nbOrdersBy(date: string, operation: string) {
    let orders = this.ordersPerDate.get(date);
    orders = orders.filter(o => o.contextName === operation);
    let nb: number = 0;
    orders.forEach(o => {
      if (o.missions)
        nb = nb + o.missions.length;
      if (o.pearlsPlanningEntries)
        nb = nb + o.pearlsPlanningEntries.length;
    })
    return nb;
  }


  searchOrders() {

    this.loadingComplete = false;
    this.orders = [];
    this.showPresenceCheckInfosPerOp = new Map();

    this.showOperationPlanning = true;

    this.photoCounters = new Map();
    this.ordersPerDate = new Map();

    this.ordersPerDateKeys = [];
    this.ordersPerOperationKeys = [];


    this.orderService.loadOrderReport(this.currentMonth.getStartMonth(), this.currentMonth.getEndMonth(), this.selectedOperationId).then(report => {
      this.planningReport = report;
      this.orders = report.getAllOrders();

      let operationSettingsCache = [];

      // -- we want to store in cache the operation settings
      let allP = [];
      let allOperationIds: number[] = [];

      if (report.days != null)
        report.days.forEach(day => {

          if (day.operationReports != null)
            day.operationReports.forEach(opRep => {

              if (opRep.planningEntry.planningEntryType === 'LOGA') {
                if (allOperationIds.indexOf(opRep.operationId) < 0)
                  allOperationIds.push(opRep.operationId);
              }

            });

        })

      for (let id of allOperationIds) {
        allP.push(this.operationService.loadOperationCustomerPlanningSettings(id).then(planificationSettings => {
          operationSettingsCache[id] = planificationSettings;
          this.showPresenceCheckInfosPerOp.set(id, planificationSettings.showPresenceCheckInfos)
        }));
      }

      console.log(JSON.stringify(report.days))

      //
      Promise.all(allP).then(() => {

        for (const day of report.days) {

          if (day.operationReports != null && day.operationReports.length > 0) {

            for (const operationReport of day.operationReports) {

              if (operationReport.planningEntry.missions || operationReport.planningEntry.pearlsPlanningEntries) {
                let startDate = this.dateService.toDate(day.logaDay).toDateString();
                if (!this.ordersPerDate.has(startDate)) {
                  this.ordersPerDate.set(startDate, []);
                }

                // save the operation or context name
                operationReport.planningEntry.contextName = operationReport.label;
                this.ordersPerDate.get(startDate).push(operationReport.planningEntry);

                //
                if (!this.ordersPerDateKeys.find(d => d === startDate))
                  this.ordersPerDateKeys.push(startDate);

                //
                if (!this.ordersPerOperationKeys.find(opName => opName === operationReport.label))
                  this.ordersPerOperationKeys.push(operationReport.label);

                //
                for (let mission of operationReport.planningEntry.missions) {
                  this.orders.push(mission);

                  // save the operation Id
                  if (!this.logaOperationPerName.has(mission.operation.name)) {
                    this.logaOperationPerName.set(mission.operation.name, mission.operation.id);
                  }

                  mission.uiPresenceCheckString = this.showAlerts(mission.pcheckAlerts)
                }

              }

            }
          }
        }

        this.runSearch();
        this.loadingComplete = true;
      });
    });
  }

  newOrder() {
    return this.navCtrl.push(StartOrderPage, {
      operationId: this.selectedOperationId,
      operationName: this.selectedOperationName
    });
  }

  showAlerts(pcheckAlerts: any[]): string {
    let alert: string = '';

    if (pcheckAlerts != null) {
      pcheckAlerts.forEach(a => {
        alert = alert.concat(a);
      });
    }
    return alert;
  }


  public showPresenceCheckInfos(p_operation: number): boolean {
    if (this.showPresenceCheckInfosPerOp !== undefined)
      return this.showPresenceCheckInfosPerOp.get(p_operation);

    return false;
  }

  toggleShowSearch() {
    this.uiShowSearch = !this.uiShowSearch;
  }

  areaChange() {
    this.currentSectorId = null;
    this.runSearch();
  }

  sectorChange() {
    this.runSearch();
  }

  runSearch() {

    this.orders.forEach(o => {

      let hideMe = false;

      if (!hideMe && this.currentSectorId != null) {
        if (this.currentSectorId != o.location.customerSector)
          hideMe = true;
      }

      if (!hideMe && this.currentAreaId != null) {
        if (this.currentAreaId != o.location.customerArea)
          hideMe = true;
      }

      if (!hideMe && this.uiSearchWork != null && this.uiSearchWork.length > 2) {
        let isOk = false;

        if (o.location == null) {
          isOk = false;
        } else if (o.location.name.toUpperCase().indexOf(this.uiSearchWork.toUpperCase()) >= 0) {
          isOk = true;
        } else if (o.location.address != null && o.location.address.city != null && o.location.address.city.toUpperCase().indexOf(this.uiSearchWork.toUpperCase()) >= 0) {
          isOk = true;
        } else if (o.storeAliasClientCode != null && o.storeAliasClientCode.toUpperCase().indexOf(this.uiSearchWork.toUpperCase()) > 0)
          isOk = true;


        if (!isOk)
          hideMe = true;
      }

      o.uiShouldHide = hideMe;
    });

    this.uiNumberOfVisibleOrders = this.orders.filter(o => !o.uiShouldHide).length;

  }


  onLoadPearlsPlanningEntry(planningEntryType: string, p_ctxId: number, p_planningEntryId: number, p_salesRep: number, index: number) {
    if (planningEntryType === 'STORECHECK') {
      this.locupa2Service.openLocupa2Window(`/storecheck-dashboard/` + p_ctxId + "/" + p_planningEntryId + "/" + p_salesRep);
    } else if (planningEntryType === 'EVENT') {
      this.locupa2Service.openLocupa2Window(`/event/` + p_ctxId + "/" + p_planningEntryId + "/" + p_salesRep);
    }
  }
}





// WEBPACK FOOTER //
// ./src/pages/order-list/monthly-view.ts